import OfferModel from '../models/OfferModel';

export default class OffersCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = OfferModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH
      + appConstants.EndPoints.OFFER_REPLIES_CREATE_PATH
    );
  }

  parse(data) {
    return data.offers ? data.offers : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.REQUEST_OFFER:
        Utils.setMakeshiftTokenHeader();
        var offerReplyURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.OFFER_REPLIES_CREATE_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')],
          );

        let offers_store = OffersStore.get(
          payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')],
        );
        offers_store.save(
          { id: payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')] , ignore_conflict: false },
          {
            wait: true,
            url: offerReplyURL,
            type: 'POST',
            contentType: 'application/json',
            success: OffersStore.onOfferReplyHandler,
            error: OffersStore.onOfferReplyError,
          },
        );

        break;
      case ActionTypes.REQUEST_OFFER_WITH_CONFLICT:
        Utils.setMakeshiftTokenHeader();
        var offerReplyURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.OFFER_REPLIES_CREATE_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')],
          );

        let offers_conflict_store = OffersStore.get(
          payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')],
        );
        offers_conflict_store.save(
          { id: payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')], ignore_conflict: true },
          {
            wait: true,
            url: offerReplyURL,
            type: 'POST',
            contentType: 'application/json',
            success: OffersStore.onOfferReplyHandler,
            error: OffersStore.onOfferReplyError,
          },
        );

        break;
      case ActionTypes.CANCEL_REQUEST_OFFER:
        Utils.setMakeshiftTokenHeader();
        var offerCancelURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.OFFER_REPLIES_DELETE_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')],
          );

        offers_store = OffersStore.get(payload.postData.shiftID);
        offers_store.save(
          { available_shift_reply_id: null },
          {
            url: offerCancelURL,
            type: 'DELETE',
            contentType: 'application/json',
            success: OffersStore.onOfferCancelHandler,
            error: OffersStore.onOfferCancelError,
          },
        );
        break;
    }
  }
}
